const getQueryVariable = (variable) => {
  var query = window.location.search.substring(1);
  let index = query.indexOf(variable);
  if (index >= 0) {
    query = query.substring(index + variable.length);
    query =
      query.indexOf("&") > 0 ? query.substring(1, query.indexOf("&")) : query;
    return query;
  }
  console.log("Query variable %s not found", variable);
  return null;
};

export default getQueryVariable;



// WEBPACK FOOTER //
// ./src/common/actions/query.ts